import { render } from "./PCSistemaPesado.vue?vue&type=template&id=380df720"
import script from "./PCSistemaPesado.vue?vue&type=script&lang=js"
export * from "./PCSistemaPesado.vue?vue&type=script&lang=js"

import "./PCSistemaPesado.vue?vue&type=style&index=0&id=380df720&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__